var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const track = (eventName_1, params_1, ...args_1) => __awaiter(void 0, [eventName_1, params_1, ...args_1], void 0, function* (eventName, params, poll = 0) {
    //@ts-expect-error
    if (!window.umami) {
        if (poll < 10) {
            console.warn('Umami not loaded. Retrying in 1 second...', eventName, params);
            setTimeout(() => track(eventName, params, poll + 1), 1000);
            return;
        }
        console.warn('Umami not loaded. No retry.');
        return;
    }
    //@ts-expect-error
    return window.umami.track(eventName, params);
});
